import { c as _c } from "react/compiler-runtime";
import { AlertTriangle, ThumbsUp } from 'lucide-react';
import type { PlanFeatureUsageMarker } from '../plan-comparison';
import { badgeVariants } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
type FeatureUsageMarkerProps = {
  marker: PlanFeatureUsageMarker;
};
export function FeatureUsageMarker(t0) {
  const $ = _c(15);
  const {
    marker
  } = t0;
  if (marker.variant === "solid") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = cn(badgeVariants({
        variant: "outline"
      }), "cursor-help rounded-md border-transparent bg-white/[0.04] font-normal text-zinc-400");
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== marker.text || $[2] !== t1) {
      t2 = <TooltipTrigger asChild={true}><span className={t1}>{marker.text}</span></TooltipTrigger>;
      $[1] = marker.text;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <TooltipContent className="whitespace-normal text-sm font-normal tracking-wide" style={{
        maxWidth: "300px"
      }} sideOffset={6}>Your team used this during the trial.</TooltipContent>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t2) {
      t4 = <TooltipProvider><Tooltip delayDuration={100}>{t2}{t3}</Tooltip></TooltipProvider>;
      $[5] = t2;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const Icon = marker.tone === "warning" ? AlertTriangle : ThumbsUp;
  let t1;
  if ($[7] !== Icon) {
    t1 = <TooltipTrigger asChild={true}><Icon className="size-4 cursor-help text-orange-400" /></TooltipTrigger>;
    $[7] = Icon;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      maxWidth: "300px"
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== marker.text) {
    t3 = <TooltipContent className="whitespace-normal text-sm font-normal tracking-wide" style={t2} sideOffset={6}>{marker.text}</TooltipContent>;
    $[10] = marker.text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = <TooltipProvider><Tooltip delayDuration={100}>{t1}{t3}</Tooltip></TooltipProvider>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}